import { HttpService } from "@/core";
import {
  echartReq,
  ProjectPageReq,
  ProjectPageResp,
  ProjectDetail,
  BriefingResp,
  CumulativeCostResp,
  MaterialCostResp,
  ProjectClueResp,
  DonutchartDiscardResp,
  ProjectBidResp,
  DictionariesArrResp,
  QualityCheckResp,
  SafetyCheckResp,
  ComprehensiveAnalysisResp,
  StaticsQualityResp,
  QualityStatusResp,
  FundingAnalysisResp,
  FundingBudgetResp,
  FundingSurplusResp,
  CostAnalysisResp,
  costAmountResp,
  ProjectCostWarningResp,
} from "./project-board.interface";
export class ProjectService {
  // 项目状态分页
  static useProjectPageApi() {
    const api = (params: ProjectPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/project/simple/page",
        params,
      });
    return HttpService.usePagination<ProjectPageResp>(api);
  }
  // 数据看板数据
  static useProjectPageApis() {
    const api = (params: ProjectPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/project/simple/page/new",
        params,
      });
    return HttpService.usePagination<ProjectPageResp>(api);
  }
  // 根据项目id获取合同列表
  static useProjectContractPageApis() {
    const api = (id) =>
      HttpService.axios({
        method: "GET",
        url: `/project/simple/page/new/${id}`,
      });
    return HttpService.usePagination<ProjectPageResp>(api);
  }
  // 项目详情
  static useProjectDetailApi() {
    const api = (id: String) =>
      HttpService.axios({
        method: "GET",
        url: `/project/simple/${id}`,
      });
    return HttpService.useRequest<ProjectDetail>(api);
  }

  static useEarlyBriefingApi() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: "/data_board/data/briefing",
      });
    return HttpService.useRequest<BriefingResp>(api);
  }

  static useEarlyCumulativeCostApi() {
    const api = (params: echartReq) =>
      HttpService.axios({
        method: "GET",
        url: "/data_board/dashboard/cumulativeCost",
        params,
      });
    return HttpService.useRequest<CumulativeCostResp>(api);
  }

  static useEarlyMaterialCostApi() {
    const api = (params: echartReq) =>
      HttpService.axios({
        method: "GET",
        url: "/data_board/dashboard/materialCost",
        params,
      });
    return HttpService.useRequest<MaterialCostResp>(api);
  }

  // 项目线索漏斗
  static useEarlyClueFunnelApi() {
    const api = (params: echartReq) =>
      HttpService.axios({
        method: "GET",
        url: "/data_board/funnel/project/clue",
        params,
      });
    return HttpService.useRequest<ProjectClueResp>(api);
  }

  // 项目线索丢单饼图
  static useEarlyCluePieApi() {
    const api = (params: echartReq) =>
      HttpService.axios({
        method: "GET",
        url: "/data_board/donutchart/discard",
        params,
      });
    return HttpService.useRequest<DonutchartDiscardResp>(api);
  }

  // 投标漏斗
  static useEarlyBidFunnelApi() {
    const api = (params: echartReq) =>
      HttpService.axios({
        method: "GET",
        url: "/data_board/funnel/project/bid",
        params,
      });
    return HttpService.useRequest<ProjectBidResp>(api);
  }

  // 落标原因饼图
  static useEarlyBidPieApi() {
    const api = (params: echartReq) =>
      HttpService.axios({
        method: "GET",
        url: "/data_board/donutchart/outbid",
        params,
      });
    return HttpService.useRequest<DictionariesArrResp>(api);
  }

  // 项目状态柱状图
  static useEarlyStatusCategoryApi() {
    const api = (params: echartReq) =>
      HttpService.axios({
        method: "GET",
        url: "/data_board/donutchart/project/status",
        params,
      });
    return HttpService.useRequest<DictionariesArrResp>(api);
  }

  // 成本分析圆环
  static useEarlyCostPieApi() {
    const api = (params: echartReq) =>
      HttpService.axios({
        method: "GET",
        url: "/data_board/donutchart/cost",
        params,
      });
    return HttpService.useRequest<DictionariesArrResp>(api);
  }

  // 质量分析柱状图
  static useEarlyQualityCategoryApi() {
    const api = (params: echartReq) =>
      HttpService.axios({
        method: "GET",
        url: "/data_board/chart/quality/check",
        params,
      });
    return HttpService.useRequest<QualityCheckResp>(api);
  }

  // 安全分析柱状图
  static useEarlySecurityCategoryApi() {
    const api = (params: echartReq) =>
      HttpService.axios({
        method: "GET",
        url: "/data_board/chart/safety/check",
        params,
      });
    return HttpService.useRequest<SafetyCheckResp>(api);
  }

  // 项目看板

  // 项目详情

  static useProjectAnalysisApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/statics/comprehensive/analysis`,
        params,
      });
    return HttpService.useRequest<ComprehensiveAnalysisResp>(api);
  }

  // 质量分析统计
  static useProjectQualityApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/statics/quality`,
        params,
      });
    return HttpService.useRequest<StaticsQualityResp>(api);
  }

  // 质量分析折线图
  static useProjectQualityCategoryApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/chart/quality/check`,
        params,
      });
    return HttpService.useRequest<QualityCheckResp>(api);
  }

  // 质量分析饼图
  static useProjectQualityPieApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/statics/quality/status`,
        params,
      });
    return HttpService.useRequest<QualityStatusResp>(api);
  }

  // 资金分析统计
  static useProjectFundingApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/statics/funding/analysis`,
        params,
      });
    return HttpService.useRequest<FundingAnalysisResp>(api);
  }

  // 资金分析统计收支折线
  static useProjectFundingBudgetApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/chart/funding/budget`,
        params,
      });
    return HttpService.useRequest<FundingBudgetResp>(api);
  }

  // 资金分析统计收支折线
  static useProjectFundingSurplusApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/chart/funding/surplus`,
        params,
      });
    return HttpService.useRequest<FundingSurplusResp>(api);
  }

  // 成本统计
  static useProjectCostApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/statics/cost/analysis`,
        params,
      });
    return HttpService.useRequest<CostAnalysisResp>(api);
  }

  // 成本统计 环形图
  static useProjectCostPieApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/donutchart/cost/project`,
        params,
      });
    return HttpService.useRequest<DictionariesArrResp>(api);
  }

  // 成本统计 折线图
  static useProjectCostCategoryApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/chart/cost/amount`,
        params,
      });
    return HttpService.useRequest<costAmountResp>(api);
  }

  // 安全统计
  static useProjectSafetyApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/statics/safety`,
        params,
      });
    return HttpService.useRequest<StaticsQualityResp>(api);
  }
  // 安全统计 折线图
  static useProjectSafetyCategoryApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/chart/safety/check`,
        params,
      });
    return HttpService.useRequest<SafetyCheckResp>(api);
  }

  // 安全统计 扇形
  static useProjectSafetyPieApi() {
    const api = (params: { projectId: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board_project/statics/safety/status`,
        params,
      });
    return HttpService.useRequest<QualityStatusResp>(api);
  }

  //材料对比接口
  static useCostWarningApi() {
    const api = (data:any) =>
      HttpService.axios({
        method: "POST",
        url: `/data_board/current/${data.purchaseOrderInfoReq.projectId}/material/contrast`,
        data,
      });
    return HttpService.useRequest<ProjectCostWarningResp>(api);
  }
  static useCostWarningApi2() {
    const api = (params: { id: String }) =>
      HttpService.axios({
        method: "GET",
        url: `/data_board/${params.id}/material/contrast`,
      });
    return HttpService.useRequest<ProjectCostWarningResp>(api);
  }
}
